import StatusSelectorFlexWrap from './status-selector-flex-wrap';

export default StatusSelectorFlexWrap;
